import{useRef as t,useState as r,useCallback as o}from"react";function e({controlled:e,default:n}){const{current:c}=t(void 0!==e),[u,a]=r(n);return[c?e:u,o((t=>{c||a(t)}),[])]}export{e as default};
